<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-4">
                        {{this.parentObject.pageTitle}} <span style="color: green;">{{ this.parentObject.pageTitleValue }}</span>
                    </h2>
                </v-row>
                <v-row>
                    <div class="pl-3 pb-2">
                        <v-row>
                            <v-col>
                                <v-btn color="warning" style="width: 70px;" @click="backHandler">
                                    {{$t('button.back') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
                    <v-row>
                        <v-col cols="4" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexercise')"
                                type="text"
                                ref="reviewcode"
                                v-model="formData.reviewcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="8" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexercisedescription')"
                                type="text"
                                ref="description"
                                v-model="formData.description"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('appraisalrecord.reviewtype')"
                                type="text"
                                ref="type"
                                v-model="formData.assessmentcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.startdate')"
                                type="date"
                                ref="startdate"
                                v-model="formData.startdate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.enddate')"
                                type="date"
                                ref="enddate"
                                v-model="formData.enddate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                ref="staffname"
                                v-model="formData.staffname"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.staffid')"
                                type="text"
                                ref="staffcode"
                                v-model="formData.staffcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.company')"
                                type="text"
                                ref="staffcompany"
                                v-model="formData.staffcompany"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1" sm="1" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('Setupratingscaleset.score')"
                                type="text"
                                ref="score"
                                v-model="formData.score"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" sm="1" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('Setuprankingset.rank')"
                                type="text"
                                ref="rank"
                                v-model="formData.rank"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                 
                    <!-- KIV on usage-->
                    <!-- <app-formbuttons
                        v-on:SavePressed="saveHandler"
                        v-on:CancelPressed="cancelHandler" 
                    /> -->

                    <v-row class="pb-n4 pl-2">
                        <app-table
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                staffcode: this.formData.staffcode,
                                pmreviewexercisedid: this.formData.id,
                                method: this.formData.method,
                                detailItem: this.parentObject.reviewerList,
                                staffData: this.formData,
                            }"
                        />
                    </v-row>
                
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableStaffReviewer';


export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: this.parentObject.data.id,
                pmreviewexerciseid : this.parentObject.data.pmreviewexerciseid || this.$route.params.indKPIData.pmreviewexerciseid,
                pmrankmapsetid : this.parentObject.data.pmrankmapsetid,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                formtype: this.parentObject.data.formtype,
                type: this.parentObject.data.formtype,
                staffid: this.parentObject.data.staffid || this.$route.params.indKPIData.staffid,
                staffname: this.parentObject.data.staffname,
                staffcode: this.parentObject.data.staffcode,
                staffcompany : this.parentObject.data.staffcompany,
                score: this.parentObject.data.score, 
                rank: this.parentObject.data.rank, 
                initiated: this.parentObject.data.initiated,
                ongoing: this.parentObject.data.ongoing,
                completed: this.parentObject.data.completed,
                totalRecords: this.parentObject.data.totalRecords,
                method: this.parentObject.data.method,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

      
            errMsg: '',
            isErr: false,
            search: this.parentObject.searchnew,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffcode', width: '200px', sortable: true},
                { text: this.$t('columns.staffname'), value: 'staffname', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewfrom'), value: 'reviewfromdate', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewuntil'),value: 'reviewuntildate', width: '200px', sortable: true},
                { text: this.$t('columns.status'), value: 'statusdesc', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewtype'), value: 'reviewertypename', width: '200px', sortable: true},
                { text: this.$t('Setupratingscaleset.score'), value: 'score', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.factor'), value: 'factor', width: '200px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '200px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '200px', sortable: true},
            ],
        }
    },

    methods: {
        backHandler() {
            this.$router.push({ name: "reviewexercisestaff", params: { id: this.parentObject.data.pmreviewexerciseid, item: this.formData } });
        },
    },

    mounted() {
    },
}
</script>

<style scoped>
</style>